
/**
	* when called, check to see if we are authorized.  If not, then show the login modal.
	* my thinking is if the site doesn't need auth, then we don't put the tag in.
	*/

import { WDSiteNavbarMenu } from './wd-site-navigation';

export default class WDAuthMenu extends WDSiteNavbarMenu
{

	#rootMenu;

	connectedCallback()
	{
		WDAuth.on('auth:authorized', () => this.buildMenu());
		WDAuth.on('auth:logout', () => this.destroyMenu());
	};

	destroyMenu()
	{
		if (this.#rootMenu)
		{
			this.#rootMenu.remove();
			this.#rootMenu = null;
		}
	};

	buildMenu()
	{
		if (this.#rootMenu) this.#rootMenu.remove();

		if (!WDAuth.authorized)
		{
			this.buildLoginMenu();
		}
		else
		{
			this.buildProfileMenu();
		}
	};

	buildLoginMenu()
	{
		this.#rootMenu = this.add({ label: 'Login', fasIcon: 'sign-in-alt' });
		this.#rootMenu.on('click', () => this.modal(true));
	};

	buildProfileMenu()
	{
		this.#rootMenu = this.add({ label: WDAuth.account.login, fasIcon: 'user-circle' });
		
		if (WDConfig?.authMenu?.mode == 'dropdown') this.addProfileDropdown();
		else this.addProfileMenu();
	};

	addProfileDropdown()
	{
		const profileDD = this.#rootMenu.button.dropdown;

		//defaults to showing the profile if permitted, but allow disabling it
		if (WDAuth.can('EditProfile') && WDConfig?.authMenu?.showEditProfile !== false)
		{
			const editBtn = profileDD.add({ label: 'Edit Profile', fasIcon: 'user' });
			editBtn.on('click', (evt) =>
			{
				evt.stopPropagation();
				this.editProfile(evt);
			});
		}

		if (WDConfig.profileMenu)
		{
			WDConfig.profileMenu.forEach(item =>
			{
				const menuItem = profileDD.add();

				if (item.label) menuItem.label = item.label;
				if (item.icon) menuItem.icon = item.icon;
				if (item.uri) menuItem.on('click', (evt) =>
				{
					evt.stopPropagation();
					this.launcher.root(item.uri);
				});

			});
		}

		const loBtn = profileDD.add({ label: 'Logout', fasIcon: 'sign-out-alt' });
		loBtn.on('click', (evt) =>
		{
			evt.stopPropagation();
			WDAuth.logout();
		});
	}

	addProfileMenu()
	{
		const submenu = this.#rootMenu.submenu;

		//defaults to showing the profile if permitted, but allow disabling it
		if (WDAuth.can('EditProfile') && WDConfig?.authMenu?.showEditProfile !== false)
		{
			const editBtn = submenu.add({ label: 'Edit Profile', fasIcon: 'user' });
			editBtn.on('click', (evt) =>
			{
				evt.stopPropagation();
				this.editProfile(evt);
			});
		}

		if (WDConfig.profileMenu)
		{
			WDConfig.profileMenu.forEach(item =>
			{
				const menuItem = submenu.add();

				if (item.label) menuItem.label = item.label;
				if (item.icon) menuItem.icon = item.icon;
				if (item.uri) menuItem.on('click', (evt) =>
				{
					evt.stopPropagation();
					this.launcher.root(item.uri);
				});

			});
		}

		const loBtn = submenu.add({ label: 'Logout', fasIcon: 'sign-out-alt' });
		loBtn.on('click', (evt) =>
		{
			evt.stopPropagation();
			WDAuth.logout();
		});
	};

	editProfile()
	{
		WDController.root('/profile');
	};

};

customElements.define('wd-auth-menu', WDAuthMenu);
